import React, { useEffect, useRef, Fragment } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import DisplayAds from 'utils/display-ads';
import buildPageTitle from 'utils/build-page-title';
import Tracking from 'utils/tracking';

import {
    LandingPageComponent,
    Ad,
} from 'web-media-ui-component';


const LandingPage = ({
    topic,
    defaultTopic,
    list,
    match,
    getLandingPageData,
    itemsBasePath,
    history,
    displayAdConfig,
    lang,
}) => {
    useEffect(() => {

        const topicId = _get(match, 'params.topicId', defaultTopic);
        Tracking.trackLandingPageView()

        if (_isEmpty(topic) || topic.id !== topicId) {

            getLandingPageData(topicId);


        } else if (defaultTopic === topicId) {
            const topicTitle = _get(topic, 'title');
        }

    }, [match.params.topicId]);

    useEffect(() => {

        const topicTitle = _get(topic, 'seoHeadline') || _get(topic, 'selection.0.title') || 'Top Videos';
        document.title = buildPageTitle(topicTitle);
        window.scrollTo(0, 0);

    }, [topic]);

    useEffect(() => {
        const topicTitle = _get(topic, 'title');

        if (!hasMounted.current) {
            return;
        }

        DisplayAds.updatePageTargeting(displayAdConfig);

    }, [topic.id]);

    useEffect(() => {

        DisplayAds.init(displayAdConfig);
        hasMounted.current = true;

        return () => {

            DisplayAds.destroySlots(displayAdConfig);

        };

    }, []);

    const hasMounted = useRef(false);

    const topicSlug = _get(topic, 'slug');
    const topicTitle = _get(topic, 'seoHeadline') || _get(topic, 'title'); // use headline for landing page title
    const topicId = _get(topic, 'id');

    const onItemClick = (slug, event, itemData, index) => {
        event.preventDefault();
        history.push({
            pathname: `/${slug}`,
            search: `?t=${topicSlug}`,
        });

        Tracking.trackLandingPageOnItemClick(event, index);

    };

    const skinAdConfig = DisplayAds.lookupDisplayAd(displayAdConfig, 'skin-ad');

    const shouldRender = _get(match, 'params.topicId', defaultTopic) === topic.id;

    if(!shouldRender) {

        return null;

    }
    return (
        <Fragment>
            <Ad
                pageTargeting={DisplayAds.updatePageTargetingPageIdWithTopicId(displayAdConfig, topicId)}
                isResponsive={_get(displayAdConfig, 'responsive')}
                adSlots={_get(skinAdConfig, 'slots')}
                targeting={_get(skinAdConfig, 'targeting')}
                isOutOfPage={_get(skinAdConfig, 'isOutOfPage')}
            />
            <LandingPageComponent
                title={topicTitle}
                listItems={list}
                topicSlug={topicSlug}
                onItemClick={onItemClick}
                itemsBasePath={itemsBasePath}
                lang={lang}
            />
        </Fragment>
    );

};

LandingPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            topicId: PropTypes.string,
        }),
    }).isRequired,
    list: PropTypes.array,
    topic: PropTypes.shape(),
    getLandingPageData: PropTypes.func,
    itemsBasePath: PropTypes.string,
    displayAdConfig: PropTypes.shape(),
};

LandingPage.defaultProps = {
    list: [],
    topic: {},
    itemsBasePath: '\/video',
    displayAdConfig: {},
    lang: 'en',
};

export default LandingPage;
